import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { driverLogout } from 'store/actions/app'
import './Header.scss'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'
import { FaChartBar } from 'react-icons/fa6'
import { NavLink } from 'react-router-dom'
import HeaderSeparator from './HeaderSeparator'
import icons from 'components/Icons.js'
import ModalMenu from 'components/ModalMenu/ModalMenu'

import {
    Button,
    Header,
    Icon,
    Image,
    Label,
    Menu,
    Message,
    Popup,
    Segment,
} from 'semantic-ui-react'

const getAvatar = (driver) => {
    let name = 'Guest'
    if (driver) {
        name = driver.name
    }
    return `https://ui-avatars.com/api/?name=${name}`
}

const HeaderComponent = (props) => {
    const { t } = useTranslation()
    const {
        driver,
        driverLogout,
        setExpand,
        openModal,
        setOpenModal,
        mobileOnly,
        previousExpand,
        setPreviousExpand,
        expand,
    } = props

    // si el sidebar está "visible" según tu lógica (null || 1) y no es mobile, desplazar header
    const isSidebarExpanded = mobileOnly ? expand === 1 : expand == null || expand === 1

    const zeroIfMobile = (base = {}) =>
        mobileOnly
            ? {
                ...base,
                margin: 0,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                padding: 0,
                paddingLeft: 0,
                paddingRight: 0,
            }
            : base

    const [modalVisible, setModalVisible] = useState(false)

    // Modal Menu (Configuración)
    const [modalMenuVisible, setModalMenuVisible] = useState(false)
    const [modalMenuTitle, setModalMenuTitle] = useState('')

    const handleModalMenuOpen = (title = '') => {
        setModalVisible(false)
        setModalMenuTitle(title)
        setModalMenuVisible(true)
    }
    const handleModalMenuClose = () => setModalMenuVisible(false)

    let userName = driver?.name || 'Guest'

    return (
        <Menu
            className='NavBar__Header'
            inverted
            borderless
            size='tiny'
            attached='top'
            fixed='top'
            style={zeroIfMobile({
                // desplazar solo en desktop cuando el lateral está expandido (null o 1)
                left: !mobileOnly && (isSidebarExpanded) ? 225 : 0,
                width: !mobileOnly && (isSidebarExpanded) ? 'calc(100% - 225px)' : '100%',
                transition: 'left 0.5s ease, width 0.5s ease',
                boxShadow: '10px 1px 12px 0px rgba(0,0,0,0.10)',
            })}
        >
            {isSidebarExpanded && (
                <div
                    className='HeaderSeparator HeaderSeparator--vertical'
                    style={zeroIfMobile({
                        width: '.1px',
                        height: '50px', // ajustar alto según necesidad
                        background: 'hsla(0, 0%, 90%, 0.00)',
                        margin: '0 6px',
                        marginLeft: '-3px',
                        //marginRight: '-1px',
                        alignSelf: 'center',
                        display: 'inline-block',
                        marginRight: '21px',
                    })}
                />
            )}

            <Menu className='SubMenu__Header' size='mini' secondary style={zeroIfMobile({
                // move the whole group (menu/dashboard/help/gps and separators) when sidebar opens
                marginLeft: (!mobileOnly && isSidebarExpanded) ? 8 : 0,
                transition: 'margin-left 0.24s ease',
                display: 'inline-flex',
                alignItems: 'center',
            })}>

                <Menu.Item fitted className='NavBar__Item' style={zeroIfMobile({ padding: 0, marginRight: 6 })}>
                    {(!isSidebarExpanded || mobileOnly) && (
                        <img
                            src='https://img.icons8.com/?size=100&id=g5dx3VExcn2X&format=png&color=000000'
                            alt='Menu'
                            className='NavBar__Item'
                            style={{
                                width: 30,
                                height: 30,
                                cursor: 'pointer',
                                display: 'inline-block',
                                verticalAlign: 'middle',
                                pointerEvents: 'auto'
                            }}
                            onClick={() => {
                                setExpand((previousExpandedState) => {
                                    setPreviousExpand(previousExpandedState)

                                    if (!mobileOnly)
                                        return previousExpandedState == 1
                                            ? previousExpand == null || previousExpand == 2
                                                ? 0
                                                : 2
                                            : 1

                                    return !previousExpandedState ? 1 : 0
                                })
                            }}
                        />
                    )}
                </Menu.Item>

                <Menu.Item fitted position='right' data-tip data-for='dashboard-tooltip' style={mobileOnly ? { padding: 0, margin: -2 } : undefined}>
                    <NavLink
                        to={'/driver/driver_dashboard'}
                        style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                        <img
                            data-tip
                            data-for='dashboard-tooltip'
                            src='https://img.icons8.com/?size=100&id=DAoPjn2XoTUN&format=png&color=000000'
                            alt='Dashboard'
                            className='NavBar__Item'
                            style={{ width: 30, height: 30, display: 'inline-block', verticalAlign: 'middle' }}
                        />
                    </NavLink>
                </Menu.Item>
                <ReactTooltip id='dashboard-tooltip' place='top' effect='solid' className='tooltip-mini' offset={{ right: 2 }}>
                    Dashboard
                </ReactTooltip>

                <Menu.Item fitted position='right' style={mobileOnly ? { padding: 0, margin: -2 } : undefined}>
                    <div
                        style={zeroIfMobile({
                            marginLeft: 4,
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "none",
                            outline: "none",
                        })}
                    >
                        <img
                            data-tip
                            data-for='help-tooltip'
                            src='https://img.icons8.com/?size=100&id=p4rXi9HURgXT&format=png&color=000000'
                            alt={t('Ayuda')}
                            className='NavBar__Item'
                            style={{ width: 30, height: 30, cursor: 'pointer' }}
                            onClick={() => { setOpenModal(!openModal) }}
                        />
                    </div>
                </Menu.Item>
                <ReactTooltip id='help-tooltip' place='top' effect='solid' className='tooltip-mini' offset={{ right: 2 }}>
                    {t('Ayuda')}
                </ReactTooltip>
            </Menu >

            <Menu.Menu
                position={mobileOnly ? null : 'right'}
                borderless
                size='tiny'
                style={!mobileOnly ? { paddingRight: 12 } : undefined}
            >
                {!mobileOnly ? <HeaderSeparator /> : undefined}
                <Menu.Item fitted position='right' className='NavBar__Item'>
                    <Popup
                        onOpen={() => setModalVisible(true)}
                        onClose={() => setModalVisible(false)}
                        open={modalVisible}
                        pinned
                        on='click'
                        trigger={
                            <Menu.Item className='NavBar__Outline NavBar__Item' fitted style={mobileOnly ? { padding: 0, margin: 0 } : undefined}>
                                <Image
                                    src={getAvatar(driver)}
                                    avatar
                                />
                                {!mobileOnly && <span className='ClientHeader__ProfileName'>
                                    {userName || ''}
                                </span>}
                            </Menu.Item>
                        }
                        content={
                            <Segment className="Header_PopUp NavBar__Outline">
                                <div className="Header_PopUp_List">

                                    {/* Logo */}
                                    <div className="Header_PopUp_Item">
                                        <div className="Header_PopUp_Button logo">
                                            <Image
                                                src={driver?.sys_company_data?.logo_url}
                                                avatar
                                            />
                                        </div>
                                    </div>

                                    {/* Username */}
                                    <div className="Header_PopUp_Item">
                                        <h4 className="NavBar__InvertedOutline">
                                            {userName?.toUpperCase()}
                                        </h4>
                                    </div>

                                    {/* Configuración */}
                                    <div className="Header_PopUp_Item">
                                        <Button
                                            onClick={() => handleModalMenuOpen(t('Configuración'))}
                                            className="Header_PopUp_Button settings"
                                        >
                                            {t('Configuración')}
                                            <img
                                                src={icons.find(i => i.title === 'ConfiguracionUser')?.url}
                                                alt={t('Configuración')}
                                                className="Header_Button_Icon"
                                            />
                                        </Button>
                                    </div>

                                    {/* Logout */}
                                    <div className="Header_PopUp_Item">
                                        <Button
                                            className="Header_PopUp_Button logout"
                                            onClick={async () => {
                                                await driverLogout(driver?.id)
                                                props.history.push(
                                                    `/login${driver?.sys_company_data?.logo_token
                                                        ? '?e=' + driver?.sys_company_data?.logo_token
                                                        : ''
                                                    }`
                                                )
                                            }}
                                        >
                                            {t('Cerrar sesión')}
                                            <img
                                                src={icons.find(i => i.title === 'LogOutUser')?.url}
                                                alt={t('Cerrar sesión')}
                                                className="Header_Button_Icon"
                                            />
                                        </Button>
                                    </div>

                                </div>
                            </Segment>
                        }

                        position='bottom right'
                    />
                </Menu.Item>
            </Menu.Menu>

            <ModalMenu
                open={modalMenuVisible}
                onClose={handleModalMenuClose}
                title={modalMenuTitle}
                profile="driver"
            />
        </Menu >
    )
}
// Redux properties remain unchanged
const mapDispatchToProps = (dispatch) => ({
    driverLogout: (option) => dispatch(driverLogout(option)),
})

const mapStateToProps = (state) => ({
    isDriverAuthenticated: !!state.app.driver,
    driver: state.app.driver,
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)
